export const MarkerPopupEntity = {
	Job: "job",
	Asset: "asset",
	Record: "record",
	Ticket: "ticket",
} as const;

export type MarkerPopupEntity =
	(typeof MarkerPopupEntity)[keyof typeof MarkerPopupEntity];
